export default class ProgressBar {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new ProgressBar;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		self.setProgress();
	}

	setProgress() {
		const self = this,
			$bars = $('.js-progress-bar');

		var delay = 0;

		$bars.each(function() {
			delay += 0.5;

			let $bar = $(this),
				$barValue = $bar.find('.js-progress-bar-value'),
				total = $bar.data('total'),
				progress = $bar.data('progress'),
				percentage = (100 / total) * progress;

			setTimeout(function() {
				$barValue.addClass('is-animating');
				$barValue.css({
					'width': percentage + '%'
				});
			}, delay);
		});
	}
}
